import { Box, Stack, Typography } from "@mui/material";
import React from "react";

export default function MobileWinnerCard({ winner }) {
  return (
    <Stack sx={{ width: "200.69px" }} marginX={3} paddingX={3}>
      <Stack
        sx={{
          background: "linear-gradient(180deg, #1729E1 0%, #2A55EF 49.48%, #0C2CE7 100%)",
          width: "100%",
          height: "39.57px",
          borderRadius: "11.63px",
          zIndex: "999",
        }}
        justifyContent="center"
        alignItems="center"
        color="white"
      >
        <Typography variant="body2">
          {`${winner.matchDetails.firstTeam} vs ${winner.matchDetails.secondTeam}`}
        </Typography>
      </Stack>
      <Box
        sx={{
          bgcolor: "white",
          borderRadius: "25px",
          height: "130px",
          marginTop: "-25px",
          width: "100%",
        }}
      >
        <Stack
          sx={{ paddingTop: "35px", paddingBottom: "5px", width: "100%" }}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{
              borderRadius: "50%",
              height: "46px",
              width: "46px",
              textAlign: "center",
              backgroundImage: 'url("/static/images/position.png")',
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              margin: 0,
            }}
            mb={0.5}
          >
            <Typography
              variant="body2"
              sx={{
                fontSize: "30px",
                color: "  #FBE88E ",
              }}
            >
              {winner.position}
            </Typography>
          </Stack>
          <Stack
            sx={{ width: "180px" }}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Typography noWrap sx={{ textOverflow: "ellipsis", width: "140px" }} variant="body2">
              {winner.userDetails?.fullname?.toUpperCase()}
            </Typography>
          </Stack>
          <Stack sx={{ width: "100%" }} direction="row" justifyContent="center" alignItems="center">
            <Typography variant="body2"> {winner.userDetails?.mobileNumber}</Typography>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
}
